module.exports = __webpack_public_path__ + "static/codesign-27d4e4804257b1c1b493b132da3cd0b0.png";